import React from "react";
import "./styles.css";

/**
 * @function UIButton 
 * @param {STRING} text - Allows us to set the button text.
 * @param {FUNCTION} onClick - Allows us to set an event handler for the button when clicked.
 * @param {STRING} className - Allows us to pass a specific className to the button for primary and secondary buttons.
 * @param {STRING} data-point - Data point that should be applied to the button
 * @returns {React.Component}
 * @example
 * <UIButton className="primary-button some-class" onClick={() => this.handleClick()} text="Some text" />
 */
export default function UIButton(props) {
  const text = props.text ?? "[Button]";
  const className = props.className ?? "";
  const onClick = props.onClick ?? null;
  const point = props["data-point"] ?props["data-point"] : props.dataPoint ?? "";

  return (
    <button className={`ui-button flex-width ${className}`} onClick={onClick} data-point={ point }>
      <span>{text}</span>
    </button>
  );
}

/**
 * @function PrimaryButton 
 * @param {STRING} text - Allows us to set the button text.
 * @param {FUNCTION} onClick - Allows us to set an event handler for the button when clicked.
 * @param {STRING} data-point - Data point that should be applied to the UIButton
 * @returns {React.Component}
 * @example
 * <PrimaryButton onClick={() => this.handleClick()} text="Some text" />
 */
export function PrimaryButton(props) {
  const point = props["data-point"] ?props["data-point"] : props.dataPoint ?? "";
  const className = props.className ?? "";

  return (
    <UIButton className={ `primary-button ${ className }` } text={props.text} onClick={props.onClick} data-point={ point } />
  );
}

/**
 * @function SecondaryButton 
 * @param {STRING} text - Allows us to set the button text.
 * @param {FUNCTION} onClick - Allows us to set an event handler for the button when clicked.
 * @returns {React.Component}
 * @example
 * <SecondaryButton onClick={() => this.handleClick()} text="Some text" />
 */
export function SecondaryButton(props) {
  const point = props["data-point"] ?props["data-point"] : props.dataPoint ?? "";
  const className = props.className ?? "";
  return (
    <UIButton className={ `secondary-button ${ className }` } text={props.text} onClick={props.onClick} dataPoint={point}/>
  );
}
